module.exports = __webpack_public_path__ + "static/media/dog.3627f0c6.svg";